export function isPrimitive(obj: any) {
  return (obj !== Object(obj));
}
